import styled from 'styled-components';
import {bordersStyles} from '../../../../utils/styles';


const StyledInvoicePaymentDetails = styled.div`
  ${bordersStyles.light};

  background-color: ${props => props.theme.colors.neutral_1};
  padding: 16px 24px;

  .approvals-tab {
    padding: 0;
  }
`;

const StyledInvoicePaymentDetailsReasonTitle = styled.span`
  color: ${props => props.theme.colors.neutral_7};
`;


export {
  StyledInvoicePaymentDetails,
  StyledInvoicePaymentDetailsReasonTitle,
}
